import moment from 'moment';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { ParentData } from '@/features/availability/routes/MyProfile';
import { AuthUser } from '@/features/auth';
import { allTimezones } from 'react-timezone-select';
import Timezones from '@/config/timezones';
import {
  AppointmentData,
  Appointments,
  Offering,
  Service,
  ServiceDetail,
  SizeConfiguration,
  WeightPriceConfiguration,
} from '@/features/availability/types';
import { formatValue } from 'react-currency-input-field';
import { DayValue } from 'react-modern-calendar-datepicker';
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
const timeStamp = [
  { label: '00:00 AM', value: '00:00:00', isSelected: false },
  { label: '00:30 AM', value: '00:30:00', isSelected: false },
  { label: '01:00 AM', value: '01:00:00', isSelected: false },
  { label: '01:30 AM', value: '01:30:00', isSelected: false },
  { label: '02:00 AM', value: '02:00:00', isSelected: false },
  { label: '02:30 AM', value: '02:30:00', isSelected: false },
  { label: '03:00 AM', value: '03:00:00', isSelected: false },
  { label: '03:30 AM', value: '03:30:00', isSelected: false },
  { label: '04:00 AM', value: '04:00:00', isSelected: false },
  { label: '04:30 AM', value: '04:30:00', isSelected: false },
  { label: '05:00 AM', value: '05:00:00', isSelected: false },
  { label: '05:30 AM', value: '05:30:00', isSelected: false },
  { label: '06:00 AM', value: '06:00:00', isSelected: false },
  { label: '06:30 AM', value: '06:30:00', isSelected: false },
  { label: '07:00 AM', value: '07:00:00', isSelected: false },
  { label: '07:30 AM', value: '07:30:00', isSelected: false },
  { label: '08:00 AM', value: '08:00:00', isSelected: false },
  { label: '08:30 AM', value: '08:30:00', isSelected: false },
  { label: '09:00 AM', value: '09:00:00', isSelected: false },
  { label: '09:30 AM', value: '09:30:00', isSelected: false },
  { label: '10:00 AM', value: '10:00:00', isSelected: false },
  { label: '10:30 AM', value: '10:30:00', isSelected: false },
  { label: '11:00 AM', value: '11:00:00', isSelected: false },
  { label: '11:30 AM', value: '11:30:00', isSelected: false },
  { label: '12:00 PM', value: '12:00:00', isSelected: false },
  { label: '12:30 PM', value: '12:30:00', isSelected: false },
  { label: '01:00 PM', value: '13:00:00', isSelected: false },
  { label: '01:30 PM', value: '13:30:00', isSelected: false },
  { label: '02:00 PM', value: '14:00:00', isSelected: false },
  { label: '02:30 PM', value: '14:30:00', isSelected: false },
  { label: '03:00 PM', value: '15:00:00', isSelected: false },
  { label: '03:30 PM', value: '15:30:00', isSelected: false },
  { label: '04:00 PM', value: '16:00:00', isSelected: false },
  { label: '04:30 PM', value: '16:30:00', isSelected: false },
  { label: '05:00 PM', value: '17:00:00', isSelected: false },
  { label: '05:30 PM', value: '17:30:00', isSelected: false },
  { label: '06:00 PM', value: '18:00:00', isSelected: false },
  { label: '06:30 PM', value: '18:30:00', isSelected: false },
  { label: '07:00 PM', value: '19:00:00', isSelected: false },
  { label: '07:30 PM', value: '19:30:00', isSelected: false },
  { label: '08:00 PM', value: '20:00:00', isSelected: false },
  { label: '08:30 PM', value: '20:30:00', isSelected: false },
  { label: '09:00 PM', value: '21:00:00', isSelected: false },
  { label: '09:30 PM', value: '21:30:00', isSelected: false },
  { label: '10:00 PM', value: '22:00:00', isSelected: false },
  { label: '10:30 PM', value: '22:30:00', isSelected: false },
  { label: '11:00 PM', value: '23:00:00', isSelected: false },
  { label: '11:30 PM', value: '23:30:00', isSelected: false },
];
const Utils = {
  DEFAULT_PET_SIZE: 's',
  SERVICE_TYPES: {
    GROOMING: 'grooming',
    DAY_CARE: 'day-care',
    BOARDING: 'boarding',
  },
  ACCOMODATION_TYPES: {
    DAY_CARE: 'daycare',
    BOARDING: 'boarding',
    GROOMING: 'grooming',
  },
  BREED_UNSPECIFIED: 'Unspecified',
  DEFAULT_PET_SIZE_RANKINGS: ['s', 'm', 'l', 'xl', 'xs'],
  VACCINE_DATES : {
    TAKEN_DATE: 'takenDate',
    EXPIRY_DATE: 'expiryDate',
  },
  isValidEmail: (email: string) => {
    const re = /^\w+([\\.-]?\w+)@\w+([\\.-]?\w+)(\.\w{1,8})+$/;

    if (!re.test(email)) {
      return false;
    }
    return true;
  },
  
  formatDateToString: (inputDateStr: string) => {
    const inputDate = new Date(inputDateStr);
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const day = inputDate.getDate();
    const month = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const formattedDate = `${day} ${monthNames[month]} ${year}`;
    return formattedDate;
  },
  getAMPMtime: (hour?: any) => {
    return moment(hour, ['HH:mm:ss']).format('hh:mma');
  },
  getAMPMtimeWithoutFormat: (hour?: any, timezone?: string) => {
    if (timezone) return moment(hour).tz(timezone).format('hh:mma');

    return moment(hour).format('hh:mma');
  },
  getOnlyDate: (hour?: any, timezone?: string, format = 'dddd MMM DD, yyyy') => {
    if (timezone) return moment(hour).tz(timezone).format(format);

    return moment(hour).format(format);
  },
  getTzAbbr(timezone?: string) {
    if (!timezone) return '';

    return Timezones[timezone].abbr;
  },
  getDetailedTz(timezone?: string) {
    if (!timezone) return '';

    return Timezones[timezone].fullName;
  },
  getDuration: (duration: number) => {
    const minutes = duration % 60;
    const hours = Math.abs(duration - minutes) / 60;
    const parts = [];

    if (hours) parts.push(`${hours}h`);
    if (!hours || minutes) parts.push(`${minutes}m`);

    return parts.join(' ');
  },
  getDurationDiff: (start: any, end: any) => {
    const duration = moment(end).diff(start, 'minute');

    return Utils.getDuration(duration);
  },

  minutesToDhm: (minutes: number) => {
    const h = Math.floor(minutes / 60);
    const m = Math.floor(minutes % 60);
    const hDisplay = h > 0 ? h + (h == 1 ? ' hour ' : ' hours ') : '';
    const mDisplay = m > 0 ? m + (m == 1 ? ' min ' : ' mins ') : '';
    return hDisplay + mDisplay;
  },
  secondsToTime: (seconds: number) => {
    const h = Math.floor(seconds / 3600)
        .toString()
        .padStart(2, '0'),
      m = Math.floor((seconds % 3600) / 60)
        .toString()
        .padStart(2, '0'),
      s = Math.floor(seconds % 60)
        .toString()
        .padStart(2, '0');

    return h + ':' + m + ':' + s;
  },
  formatPhoneNumber: (input: string) => {
    const parsedPhoneNumber = parsePhoneNumberFromString(`+${input}`);
    if (parsedPhoneNumber && parsedPhoneNumber.countryCallingCode) {
      const countryCode = parsedPhoneNumber.countryCallingCode;
      const nationalNumber = parsedPhoneNumber.nationalNumber;
      const numericString = nationalNumber.replace(/\D/g, '');
      const areaCode = numericString.substring(0, 3);
      const localNumber = numericString.substring(3);
      const formattedNumber = `+${countryCode} (${areaCode}) ${localNumber.substring(
        0,
        3
      )}-${localNumber.substring(3)}`;

      return formattedNumber;
    } else {
      return input;
    }
  },
  getDay: (no?: number) => {
    let day = '';
    switch (no) {
      case 1: {
        day = 'SUN';
        break;
      }
      case 2: {
        day = 'MON';
        break;
      }
      case 3: {
        day = 'TUE';
        break;
      }
      case 4: {
        day = 'WED';
        break;
      }
      case 5: {
        day = 'THU';
        break;
      }
      case 6: {
        day = 'FRI';
        break;
      }
      case 7: {
        day = 'SAT';
        break;
      }
    }
    return day;
  },
  scrollToTop: () => {
    let element: HTMLElement | null = document.getElementById('main-scroll-container');
    const innerElement: HTMLElement | null = document.getElementById('righ-side-scroller');
    if (!element) element = document.getElementById('schedule-appointment');
    if (element) {
      window.scrollTo(0, 0);
      element.scroll({ top: 0 });
    }
    if (innerElement) {
      innerElement.scroll({ top: 0 });
    }
  },
  getAddress:  (parent:ParentData|AuthUser) => {
    return `${parent.address ? `${parent.address},`: ''} ${parent.apt? `${parent.apt},`: ''} ${parent.city ? `${parent.city},`: ''} ${parent.state ? parent?.state : ''} ${parent.zip? `${parent.zip},`: ''} ${parent?.country ? parent?.country : ''}` 
  },
  fromServerTz: (date?: any, serverTimezone?: string) => {
    return new Date(
      serverTimezone ?  moment(date)
        .tz(serverTimezone)
        .format('YYYY-MM-DDTHH:mm:ss') :  moment(date)
        .format('YYYY-MM-DDTHH:mm:ss')
    );
  },
  formatDateStringTz(inputDate: any, timezone?: string, dateFormat = 'MMM DD, yyyy') {
    if (timezone) return moment(inputDate).tz(timezone).format(dateFormat);

    return moment(inputDate).format(dateFormat);
  },
  toServerTz: (date?: any, serverTimezone?: string) => {
    return moment.tz(moment(date).format('YYYY-MM-DDTHH:mm:ss'), serverTimezone as string).toDate();
  },
  getDefaultPriceFromService: (service: Service | any, t?:any, currency?: any) => {
    let price: any = service.price;
    if (service.petSizePricing) {
      for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
        const defaultSize = Utils.DEFAULT_PET_SIZE_RANKINGS[i];
        const defaultPrice = service?.petSizePricing[defaultSize]?.price ?  parseFloat(service.petSizePricing[defaultSize]?.price) : 0;
        if (defaultPrice > 0) {
          price = defaultPrice;
          break;
        }
      }
    }

    return formatValue({
      value: '' + (price ? price : 0),
      groupSeparator: ',',
      decimalSeparator: '.',
      prefix: `${currency}`,
    });
  },
  getPriceFromService: (service: Service | any | undefined, petSize?: string) => {
    let price: string | number = 0;
    if (!service) {
      price = 0;
    } else {
      price = service.price;
      if (service.petSizePricing) {
        if (petSize && service.petSizePricing[petSize as keyof typeof service.petSizePricing]) {
          price = service.petSizePricing[petSize as keyof typeof service.petSizePricing]?.price;
        } else {
          for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
            const defaultSize = Utils.DEFAULT_PET_SIZE_RANKINGS[i];
            const defaultPrice = service?.petSizePricing[defaultSize]?.price ? parseFloat(service.petSizePricing[defaultSize]?.price) : 0;
            if (defaultPrice > 0) {
              price = defaultPrice;
              break;
            }
          }
        }
      }
    }
    return parseFloat(price as string);
  },
  getDurationFromService: (
    service: Service | ServiceDetail | undefined | any,
    petSize?: string
  ) => {
    let duration = 0;
    if (!service) {
      duration = 0;
    } else {
      duration = service.duration;
      if (service.petSizePricing) {
        if (petSize) {
          duration =
            service.petSizePricing[petSize as keyof typeof service.petSizePricing]?.duration;
        } else {
          for (let i = 0; i < Utils.DEFAULT_PET_SIZE_RANKINGS.length; i++) {
            const defaultSize = Utils.DEFAULT_PET_SIZE_RANKINGS[i];
            const defaultPrice = service.petSizePricing[defaultSize]?.price ? parseFloat(service.petSizePricing[defaultSize].price) : 0;
            if (defaultPrice > 0) {
              duration = service.petSizePricing[defaultSize]?.duration;
              break;
            }
          }
        }
      }
    }
    return duration;
  },
  roundDecimal: (number: any) => {
    return number ? number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] : number;
  },
  getAddonsPrice: (selectedAddonServices: Service[]) => {
    let total = 0;
    if (selectedAddonServices && selectedAddonServices?.length > 0) {
      selectedAddonServices.forEach((sas: any) => {
        total = total + parseFloat(sas.price);
      });
    }
    return total;
  },
  getFormattedPrice: (amount: number | string, t?:any) => {
    if (amount == 0) {
      return `${t('USD')} 0`;
    }
    let planPrice = amount ? amount.toString() : '';
    planPrice =
      planPrice.substring(0, planPrice.length - 2) +
      '.' +
      planPrice.substring(planPrice.length - 2);

    return formatter.format(parseFloat(planPrice));
  },
  getSelectedAddonsIds: (selectedAddonServices: Service[] | undefined) => {
    let ids = undefined;
    if (selectedAddonServices && selectedAddonServices.length) {
      ids = [];
      selectedAddonServices.forEach((sas) => {
        if (sas.id) {
          ids.push(parseInt(sas.id));
        }
      });
    }
    return ids;
  },
  getRoomPrice: (perHourPrice: number, duration: number) => {
    const hours = perHourPrice * (duration / 60);
    return hours;
  },
  totalDaysBooked: (data?: AppointmentData, appointment?: Appointments, tz?:string) => {
    let totalDaysBooked = null;
    if (
      data &&
      (data?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING ||
        data?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING) &&
      data.startDate &&
      data.endDate
    ) {
      const startDate = tz ? moment(data.startDate).tz(tz) : moment(data.startDate).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
      const endDate = tz ? moment(data.endDate).tz(tz) : moment(data.endDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      const noOfDays = endDate.diff(startDate, 'days');
      totalDaysBooked = noOfDays > 1 ? noOfDays + ' Days' : noOfDays + ' Day';
    } else if (
      appointment &&
      appointment?.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING &&
      appointment.startTime &&
      appointment.endTime
    ) {
      const startDate =tz ? moment(appointment.startTime).tz(tz) : moment(appointment.startTime).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
      const endDate =tz ? moment(appointment.endTime).tz(tz) : moment(appointment.endTime).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      const noOfDays = endDate.diff(startDate, 'days');
      totalDaysBooked = noOfDays > 1 ? noOfDays + ' Days' : noOfDays + ' Day';
    }
    return totalDaysBooked;
  },
  getTimeLabel: (time?: string) => {
    const fts = time && timeStamp.find((ts) => ts.value === time);
    return fts ? fts.label : '11:00 AM';
  },
  getOfferingService : (offerings?:Offering) => {
    let offerringCount = 0;
    let selectedOffering = offerings ? '' : Utils.SERVICE_TYPES.GROOMING;
    if(offerings?.grooming) {
      offerringCount++;
      selectedOffering = Utils.SERVICE_TYPES.GROOMING
    }
    if(offerings?.boarding) {
      offerringCount++;
      selectedOffering = Utils.SERVICE_TYPES.BOARDING
    }
    if(offerings?.daycare) {
      offerringCount++;
      selectedOffering = Utils.SERVICE_TYPES.DAY_CARE
    }
    if(offerringCount ===1 || offerringCount ===0) {
      return {selectedOffering: selectedOffering, count: offerringCount}
    }
    return {selectedOffering: undefined , count:offerringCount};
  },
  getPetTypes: (petTypes?: string[]) => {
    if(petTypes?.length === 1) {
      return petTypes[0].toLowerCase() === 'cat' ? 'cat' : 'dog';
    } else {
      return "";
    }
  },
  parseMMDDYYYY : (dateStr: string): DayValue => {
    if (!dateStr) return null;
  
    const [monthStr, dayStr, yearStr] = dateStr.split("/");
    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    const year = parseInt(yearStr, 10);
  
    if (isNaN(month) || isNaN(day) || isNaN(year)) return null;
  
    return { year, month, day };
  },
  getFileSize : (fileSize?:string, decimals = 2) => {
    const bytes = fileSize ? parseInt(fileSize) : 0;
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  },
  isMobile: () => {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  
  
};

function clearNumber(value = '') {
  return value.replace(/\D+/g, '');
}

export default Utils;
